import React, { ReactNode } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { RouteComponentProps } from '../../../helpers/withRouter'
import { AnyAction } from 'redux'
import { Application } from '../../../config'
import { Page } from '../../../components'
import { images } from '../../../images'
import { appsPrivacyAndTermsOptionsSelected, appsStyleSelected } from '../../../helpers/app'
import { AuthenticatedRoutable } from '../../../models'
import literalsService from '../../../services/literals-service'
import StyledArticle from './styles'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {}

const { isAmb } = Application

class Terms extends AuthenticatedRoutable<IProps> {

  private get privacyUrl(): string {
    const options = appsPrivacyAndTermsOptionsSelected!
    return options.someLanguages ? options.privacy + literalsService.getLanguage() : options.privacy
  }

  private get termsUrl(): string {
    const options = appsPrivacyAndTermsOptionsSelected!
    return options.someLanguages ? options.terms + literalsService.getLanguage() : options.terms
  }

  private get ambContent(): ReactNode {
    return (
      <>
        { literalsService.get('ambTermsAndConditionsText') }
        { ' ' + literalsService.get('and') + ' ' + literalsService.get('termsLinkArticle') }
        <span className="link" onClick={ this.goToTerms }>{ literalsService.get('ambLinkTermsAndConditions') }.</span>
        { '\n\n' }
        { literalsService.get('visit') + ' ' }
        <span className="link" onClick={ this.goToTerms }>{ this.termsUrl }</span>
        { ' ' + literalsService.get('goToTab') + '.' }
      </>
    )
  }

  private get defaultContent(): ReactNode {
    const owner = appsPrivacyAndTermsOptionsSelected?.owner || ''
    return (
      <>
        { literalsService.get('termsAndConditionsText').replace('{0}', owner) }
        <span className="link" onClick={ this.goToPrivacyPolicy }>{ literalsService.get('linkPrivacyPolicy') }</span>
        { ' ' + literalsService.get('and') + ' ' + literalsService.get('termsLinkArticle') }
        <span className="link" onClick={ this.goToTerms }>{ literalsService.get('linkTermsAndConditions') }.</span>
      </>
    )
  }

  public componentDidMount(): void {
    super.componentDidMount()
  }

  public render(): ReactNode {
    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className="backButton" onClick={ this.handleGoBack } alt="" />
            <h3>{ literalsService.get('termsTitle', true) }</h3>
            <p className="text">
              { isAmb ? this.ambContent : this.defaultContent }
            </p>
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }

  private goToPrivacyPolicy = (): void => {
    window.open(this.privacyUrl, '_blank')
  }

  private goToTerms = (): void => {
    window.open(this.termsUrl, '_blank')
  }
}

export default connect()(Terms)
